var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiPerson = function SvgMultiPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M26.667 35v-3.333A6.667 6.667 0 0 0 20.001 25H10a6.667 6.667 0 0 0-6.667 6.667V35M15 18.333A6.667 6.667 0 1 0 15 5a6.667 6.667 0 0 0 0 13.333M36.666 34.998v-3.333a6.666 6.666 0 0 0-5-6.45M26.666 5.215a6.666 6.666 0 0 1 0 12.917"
  })));
};
export default SvgMultiPerson;